import { FC } from 'react'
export interface CrossProps {
  width?: number
  height?: number
}

const Cross: FC<CrossProps> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9.89954"
        y="9.19238"
        width="27"
        height="1"
        transform="rotate(45 9.89954 9.19238)"
        fill="currentColor"
      />
      <rect
        x="28.9915"
        y="9.89954"
        width="27"
        height="1"
        transform="rotate(135 28.9915 9.89954)"
        fill="currentColor"
      />
    </svg>
  )
}

export default Cross
